/**
 *
 * HomeLink
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import AvatarWithText from 'components/media/AvatarWithText/index.jsx';
import NewPostBadge from 'components/notifications/NewPostBadge/index.jsx';
import messages from './messages.js';
import PathItem from './PathItem.jsx';

function HomeLink() { // eslint-disable-line react/prefer-stateless-function
  return (
    <PathItem to="/home">
      <AvatarWithText icon="ss-home">
        <span>
          <FormattedMessage {...messages.home} />
          <NewPostBadge className="ms-3" />
        </span>
      </AvatarWithText>
    </PathItem>
  );
}

HomeLink.propTypes = {
  pathname: PropTypes.string.isRequired,
};

export default HomeLink;
